import { gql } from '@apollo/client'

export const GENERATE_SITEKEY = gql`
  mutation AddNewSiteKey($input: SitekeyDataInput!) {
    addNewSiteKey(input: $input) {
      message
    }
  }
`

export const UPDATE_SITEKEY = gql`
  mutation UpdateSiteKey($input: SitekeyDataInput!, $id: String!) {
    updateSiteKey(input: $input, id: $id) {
      message
    }
  }
`

export const GET_SITEKEYS_LIST = gql`
  query Sitekeys {
    sitekeys {
      Id
      AssociatedGateways {
        Code
        GatewayIds
        GatewayType
      }
      CORSURLs
      EntityId
      EntityName
      EntityNameTranslatedList {
        label
        value
        nativeLabel
      }
      EntityType
      Hosts
      SiteKey
      Type
      UserId
      Email
      BookingRedirects {
        Code
        BookingRedirect
      }
      EntityCode
      DisplayEntityCode
      WalletType
      Mode
    }
  }
`

export const GET_SITEKEY_SINGLE_ONE = gql`
  query Sitekey($sitekeyID: String!) {
    sitekey(sitekeyID: $sitekeyID) {
      Id
      AssociatedGateways {
        Code
        GatewayIds
        GatewayType
      }
      CORSURLs
      EntityId
      EntityName
      EntityNameTranslatedList {
        label
        nativeLabel
        value
      }
      EntityType
      Favicon {
        EN {
          entityID
          entityCode
          displayEntityCode
          entityType
          imageType
          fileURL
        }
        FA {
          entityID
          entityCode
          displayEntityCode
          entityType
          imageType
          fileURL
        }
      }
      Hosts
      Logo {
        EN {
          entityID
          entityCode
          displayEntityCode
          entityType
          imageType
          fileURL
        }
        FA {
          entityID
          entityCode
          displayEntityCode
          entityType
          imageType
          fileURL
        }
      }
      SiteKey
      Type
      UserId
      Email
      BookingRedirects {
        Code
        BookingRedirect
        Name
      }
      EntityCode
      DisplayEntityCode
      WalletType
      Mode
    }
  }
`
